//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as searchAction from '../action/searchAction';
import * as nondisplayAction from '../action/nondisplayAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';
import * as uiAction from '../action/uiAction';
//Func
import { lsSearchConditionInit, lsSearchConditionInitCheck } from '../func/lsSearchCondition';
import { lsSearchDisplayInit } from '../func/lsSearchDisplay';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

//Add
import Masonry from 'react-masonry-component';
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Part
import MenuSearch from './MenuSearch';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartTimeIcon from './PartTimeIcon';
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartStarIcon from './PartStarIcon';
import PartSearchCondionButtonBalloon from './PartSearchCondionButtonBalloon';

//Dialog
import DialogSearchCondition from './DialogSearchCondition';
import DialogSearchDisplay from './DialogSearchDisplay';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
//Img
import Blank from '../img/blank/blank-1x1.gif';

class Comp extends React.Component {
  constructor(props) {
    super(props);

    if (!localStorage.getItem('SearchCondition')) {
      lsSearchConditionInit();
    }

    if (!localStorage.getItem('SearchDisplay')) {
      lsSearchDisplayInit();
    }


    this.state = {
      conditionDialogVisible: false,
      displayDialogVisible: false,
      nondisplayEditPic: null,
    }
  }

  componentDidMount() {
    document.title = '会員検索 - パートナーズ';

    if ( ((new Date()) - this.props.search.datetime) > (86400*1000) ) {
      this.props.searchListGet(1, Math.floor((new Date()).getTime() / 1000), () => {
      });
    }
    else {
      window.scrollTo(0, this.props.search.scrollpos);
    }
  }

  componentWillUnmount() {
    this.props.searchScrollposEdit(window.pageYOffset);
  }

  _paging(page) {
    this.props.searchListGet(page, this.props.search.timestamp, () => {
      window.scrollTo(0, 0);
    });
  }


  _renderList = (item, index) => {

    let display = localStorage.getItem('SearchDisplay').split(',');

		return (
      <div key={index} className='box_outer'>
        <Box className='box_innner round12' boxShadow={2}>
          {
            (item.recent_singin === 1) && (
              <div
                className='ribbon_orange'
                style={{position:'absolute', top:'0px', left:'0px'}}
                onClick={ (event) => this.props.popoverOpen(event.currentTarget, '14日以内に入会した会員') }
              >
                NEW
              </div>
            )
          }

          <div style={{position:'absolute', top:'0px', right:'0px'}}>
            <IconButton
              onClick={ () => this.props.partnerOperationOpen(item.userdata_id_code, ['memo','nondisplay','refusal','breach']) }
            >
              <MoreVertSharpIcon />
            </IconButton>
          </div>

          <div style={{padding:'2%'}}>
            <div style={{textAlign:'center'}}>
              <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                <PartUserName
                  data={{
                    name: item.userdata_name,
                    sex: item.userdata_sex,
                    size: '1.4em',
                  }}
                />
              </Link>
              <div>
                {item.userdata_age}才 {item.userdata_prof_region} {item.userdata_prof_region_detail}
              </div>

            </div>
            <div className='box_left'>
              <div style={{padding:'2%'}}>
                <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                  <div align='center' style={{position: 'relative'}}>
                    <PartUserMainImg
                      mainImg={item.userdata_mainImg}
                      maxWidth={'160px'}
                      width={'100%'}
                      height={'auto'}
                      radius={'50%'}
                      lazyLoad={false}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom:'0px',
                      left:'0px',
                      right:'0px',
                      margin: 'auto',
                    }}>
                      <div className='black_trans_icon'>
                        <div style={{fontSize: '0.8em'}}>プロフ相性 {item.compatibility_point}%</div>
                        {
                          (item.character_point > 0) && (
                            <div  style={{fontSize: '0.8em'}}>
                              性格相性 <PartStarIcon count={item.character_point}　/>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </Link>
                {
                  (display.includes('photoSub')) && (
                    <div
                      style={{display:'flex', flexWrap:'wrap'}}
                    >
                      {
                        (item.photo_sub.length > 0) &&
                        item.photo_sub.map(
                          (value, index) => {
                            return (
                              <div
                                style={{
                                  display: 'inline-block',
                                  position:'relative',
                                  overflow:'hidden',
                                  verticalAlign: 'bottom',
                                  margin:'1px',
                                }}
                                key={index}
                              >
                                <LazyLoadImage
                                  src={ value }
                                  style={{width:"40px", height: "auto", boxSizing:'border-box', borderRadius:'50%'}}
                                  placeholder={<img src={Blank} style={{width:"40px", height: "40px",}} alt='' />}
                                  alt=''
                                />

                                <img
                                  src={Blank}
                                  style={{
                                    position: 'absolute',
                                    left:0,
                                    top:0,
                                    width:'100%',
                                    height:'100%',
                                  }}
                                  alt=''
                                />
                              </div>
                            );
                          }
                        )
                      }
              			</div>

                  )
                }
              </div>
            </div>

            <div className='box_right'>
              {
                (display.includes('comment') && item.userdata_prof_partner_comment.length > 0) &&
                <div
                  className='comment round12'
                  style={{fontSize:'0.9em', color:'#666', margin:'1%'}}
                >
                  {item.userdata_prof_partner_comment}
                </div>
              }
              {
                (display.includes('academic')) &&
                <div className='flexList'><div className='col'>学歴</div><div className='col'>{item.userdata_prof_academic}</div></div>
              }
              {
                (display.includes('job')) &&
                <div className='flexList'><div className='col'>仕事</div><div className='col'>{item.userdata_prof_job}</div></div>
              }
              {
                (display.includes('income')) &&
                <div className='flexList'><div className='col'>年収</div><div className='col'>{item.userdata_prof_income}</div></div>
              }
              {
                (display.includes('style')) &&
                <div className='flexList'><div className='col'>体型</div><div className='col'>{item.userdata_prof_style}</div></div>
              }
              {
                (display.includes('height')) &&
                <div className='flexList'><div className='col'>身長</div><div className='col'>{item.userdata_prof_height}cm</div></div>
              }
              {
                (display.includes('association')) &&
                <div className='flexList'><div className='col'>交際希望</div><div className='col'>{item.userdata_prof_association}</div></div>
              }
              {
                (display.includes('marriage')) &&
                <div className='flexList'><div className='col'>結婚歴</div><div className='col'>{item.userdata_prof_marriage}</div></div>
              }
              {
                (display.includes('child')) &&
                <div className='flexList'><div className='col'>子供</div><div className='col'>{item.userdata_prof_child}</div></div>
              }
              {
                (display.includes('lifestyle')) &&
                <div className='flexList'><div className='col'>生活</div><div className='col'>{item.userdata_prof_lifestyle}</div></div>
              }
              {
                (display.includes('smorking')) &&
                <div className='flexList'><div className='col'>タバコ</div><div className='col'>{item.userdata_prof_smorking}</div></div>
              }
              {
                (display.includes('drinking')) &&
                <div className='flexList'><div className='col'>お酒</div><div className='col'>{item.userdata_prof_drinking}</div></div>
              }
              {
                (display.includes('gambling')) &&
                <div className='flexList'><div className='col'>ギャンブル</div><div className='col'>{item.userdata_prof_gambling}</div></div>
              }
              {
                (display.includes('pet')) &&
                <div className='flexList'><div className='col'>ペット</div><div className='col'>{item.userdata_prof_pet}</div></div>
              }
              {
                (display.includes('memo')) &&
                <div className='flexList'><div className='col'>メモ</div><div className='col'>{item.memo}</div></div>
              }



              { (item.userdata_proof_person === 1) && (<span className='proof_icon'>本人証明</span>) }
              { (item.userdata_proof_photo === 1) && (<span className='proof_icon'>写真証明</span>) }
              { (item.userdata_proof_income === 1) && (<span className='proof_icon'>収入証明</span>) }
              { (item.userdata_proof_single === 1) && (<span className='proof_icon'>独身証明</span>) }
              { (item.userdata_proof_credit === 1) && (<span className='proof_icon'>ｸﾚｼﾞｯﾄ証明</span>) }
              { (item.post_count > 0) && (<span className='post_icon'>投稿 {item.post_count}件</span>) }
              { (item.qa_count > 0 || item.qa_answer_count > 0) && (
                <span className='qa_icon'>Q&A
                  { (item.qa_count > 0) && (item.qa_count + '問')}
                  { (item.qa_answer_count > 0) && (item.qa_answer_count + '答')}
                </span>
              ) }
              { (item.character_type16) && (<span className='personality_icon'>性格</span>) }


              {
                (display.includes('footprint') && item.footprint_partner === 1) && (
                  <span
                    className='footprint_icon'
                  >
                    <span>足あと(相手から)</span>
                  </span>
                )
              }
              {
                (display.includes('footprint') && item.footprint_my === 1) && (
                  <span
                    className='footprint_icon'
                  >
                    <span>足あと(自分から)</span>
                  </span>
                )
              }

            </div>
            <div style={{clear:'both'}} />

            <div style={{textAlign:'center'}}>
              <span
                onClick={ () => this.props.helpOpen('category','loginTime') }
              >
                <PartTimeIcon
                  text={item.userdata_login_aftertime}
                />
              </span>
            </div>
          </div>

        </Box>
      </div>
    );
  };

  render() {
    return (
      <div>
        <MenuSearch />
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent: 'space-between',
            margin: '10px',
          }}
        >
          <div>
            <span style={{position:"relative"}}>
              <Button
                color={ lsSearchConditionInitCheck() ? 'primary' : 'secondary' }
                variant={ 'outlined' }
                onClick={ () => this.setState({ conditionDialogVisible: true}) }
              >

                {
                  lsSearchConditionInitCheck() ?
                  '検索条件'  :
                  '検索条件(ON)'
                }

              </Button>
              {
                (this.props.search.searchCondionButtonBalloon && lsSearchConditionInitCheck()) &&
                (<PartSearchCondionButtonBalloon />)
              }
            </span>
            &nbsp;
            <Button
              color="primary"
              variant='outlined'
              onClick={ () => this.setState({ displayDialogVisible: true}) }
              style={{minWidth:'0px'}}
            >
              表示
            </Button>
          </div>
          <div>
            <span style={{color:'#666'}}>ページ{this.props.search.page}</span>

            <IconButton
              onClick={ () => this.props.searchListGet(1, Math.floor((new Date()).getTime() / 1000), () => {}) }
            >
              <RefreshIcon />
            </IconButton>

          </div>
        </div>



        <div id="user_list_block">
          {
            (this.props.search.datetime) && (
              <div>
              {
                (this.props.search.list.length > 0) ? (
                  <div>
                    <Masonry
                      options={{itemSelector: '.box_outer',transitionDuration: 0,}}
                      disableImagesLoaded={false}
                      updateOnEachImageLoad={true}
                    >
                    {
                      this.props.search.list.map(
                        (value, index) => this._renderList(value, index)
                      )
                    }
                    </Masonry>
                    <div style={{margin:'15px'}}>
                      <PartPagingNextPrev
                        page={this.props.search.page}
                        isNext={this.props.search.isListNext}
                        onClick={ (e) => this._paging(e) }
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <h2 align='center' style={{padding:'30px 0px'}}>
                      <span className='i-b'>該当する会員が</span>
                      <span className='i-b'>見つかりませんでした</span>
                    </h2>
                    <div align='center'>
                      <Button
                        color="primary"
                        variant={'outlined'}
                        onClick={ () => {
                          lsSearchConditionInit();
                          this.props.searchListGet(1, Math.floor((new Date()).getTime() / 1000), () => {});
                        }}
                      >
                        検索条件をリセットする
                      </Button>
                    </div>

                  </div>
                )
              }
              {
                (this.props.search.isListNext === false) && (
                  <div style={{margin:'10px'}}>
                    <div style={{margin:'5px'}}>
                      <Button
                        color="primary"
                        variant={'outlined'}
                        onClick={ () => this.props.helpOpen('id',364) }
                      >
                        検索結果が少ない場合
                      </Button>
                    </div>
                    <div style={{margin:'5px'}}>
                      <Button
                        color="primary"
                        variant={'outlined'}
                        onClick={ () => this.props.helpOpen('id',419) }
                      >
                        お探しの方が表示されない場合
                      </Button>
                    </div>
                  </div>
                )
              }
              </div>
            )
          }
        </div>


        <DialogSearchCondition
          open={this.state.conditionDialogVisible}
          onSubmit={ () => this.props.searchListGet(1, Math.floor((new Date()).getTime() / 1000), () => {}) }
          onClose={ () => this.setState({ conditionDialogVisible: false}) }
        />

        <DialogSearchDisplay
          open={this.state.displayDialogVisible}
          onClose={ () => this.setState({ displayDialogVisible: false}) }
        />

      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    search: state.search,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...searchAction,
    ...nondisplayAction,
    ...partnerOperationAction,
    ...helpAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
